import React from 'react'
import TitleToolbar from '../Page/TitleToolbar'
import ToolbarButton from '../Page/ToolbarButton'
import PdfIcon from './PdfIcon'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import PlaceIcon from '@material-ui/icons/Place'
import LinkIcon from '@material-ui/icons/Link'
import { useMatomo } from '@datapunt/matomo-tracker-react'

export default ({ loaded, selected, onToggleSelect, onViewOnMap, onLink, pdfUrl, onOpenPdf }) => {
	const { trackEvent } = useMatomo()
return (
	<TitleToolbar title="Stompunkt">
		<ToolbarButton
			title = { selected ? 'Ta bort ur urval' : 'Lägg till i urval' }
			icon = { selected ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon /> }
			onClick = {onToggleSelect}
			disabled = {!loaded}
		/>
		<ToolbarButton
			title = "Visa på karta"
			icon = {<PlaceIcon />}
			onClick = {() => {trackEvent({ category: 'Stompunkt Meny', action: 'Visa på karta',name: 'onClick' });onViewOnMap()}}
			disabled = {!loaded}
		/>
		<ToolbarButton
			title = "Länk"
			icon = {<LinkIcon />}
			onClick = {() => {trackEvent({ category: 'Stompunkt Meny', action: 'Länk',name: 'onClick' });onLink()}}
			disabled = {!loaded}
		/>
		<ToolbarButton
			title = "Ladda ned PDF"
			icon = {<PdfIcon />}
			disabled = {!loaded}
			component = "a"
			href = {pdfUrl}
			onClick = {() => {trackEvent({ category: 'Stompunkt Meny', action: 'Ladda ned PDF',name: 'onClick' });onOpenPdf()}}
			download
		/>
	</TitleToolbar>
)}



// WEBPACK FOOTER //
// ./src/components/Stompunkt/StompunktToolbar.js